import { filter } from '../CqlFilters/cqlFilters';

export const getSubstationLossInfo = async (hoverInfo) => {
    const id = hoverInfo.object.id.split('.')[1];
    const sub_loss = await filter('elektro:trafo_stanice_gubici', 'id_trafo_stanice', id);

    const relevantInfo = {
        'ID trafo stanice gubici': sub_loss[0]?.properties?.id_trafo_stanice_gubici,
        'ID trafo stanice': sub_loss[0]?.properties?.id_trafo_stanice,
        'Maksimalna mj. 15 min. snaga tr brojilo': sub_loss[0]?.properties?.maksimalna_mjesecna_15_min_snaga_tr_brojilo,
        'Potrošnja mjesečna tr ts brojila': sub_loss[0]?.properties?.potrosnja_mjesecna_tr_ts_brojila,
        'Potrošnja mjesečna konzuma na ts': sub_loss[0]?.properties?.potrosnja_mjesecna_konzuma_na_ts,
        'Gubici na ts': sub_loss[0]?.properties?.gubici_na_ts,
        'Napon na tr brojilu 1': sub_loss[0]?.properties?.napon_na_tr_brojilu_1,
        'Napon na tr brojilu 2': sub_loss[0]?.properties?.napon_na_tr_brojilu_2,
        'Napon na tr brojilu 3': sub_loss[0]?.properties?.napon_na_tr_brojilu_3,
        'Struja na tr brojilu 1': sub_loss[0]?.properties?.struja_na_tr_brojilu_1,
        'Struja na tr brojilu 2': sub_loss[0]?.properties?.struja_na_tr_brojilu_2,
        'Struja na tr brojilu 3': sub_loss[0]?.properties?.struja_na_tr_brojilu_3,
        'Trenutna 15 min. snaga na tr brojilu': sub_loss[0]?.properties?.trenutna_15_min_snaga_na_tr_brojilu,
        'Alarm sa tr brojila': sub_loss[0]?.properties?.alarm_sa_tr_brojila,
        'Prenosni odnos smt tr brojila': sub_loss[0]?.properties?.prenosni_odnos_smt_tr_brojila,
        'Saidi planirani': sub_loss[0]?.properties?.saidi_planirani,
        'Saifi planirani': sub_loss[0]?.properties?.saifi_planirani,
        'Saidi neplanirani': sub_loss[0]?.properties?.saidi_neplanirani,
        'Saifi neplanirani': sub_loss[0]?.properties?.saifi_neplanirani,
        'Saidi ukupni': sub_loss[0]?.properties?.saidi_ukupni,
        'Saifi ukupni': sub_loss[0]?.properties?.saifi_ukupni,
        'Maifi ukupni': sub_loss[0]?.properties?.maifi_ukupni,
        'Broj ispada ukupni': sub_loss[0]?.properties?.broj_ispada_ukupni,
        'Trajanje ispada ukupno': sub_loss[0]?.properties?.trajanje_ispada_ukupno,
    };

    return relevantInfo;
};